/**
 * @fileoverview PUT handler for the "/internal_user_groups/internal_user_group_update" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { internalUserGroupsInternalUserGroupUpdateCacheKeys } from "./constants";
import type {
  InternalUserGroupsInternalUserGroupUpdateResult,
  AppSettingsInternalUserGroupsInternalUserGroupUpdateOptions,
} from "./types";

const nestedPropertyData = (
  propertyData: string,
  isEnabled: boolean,
  isDefault?: boolean
): Record<string, { is_enabled: boolean; is_default?: boolean }> => {
  if (isDefault === undefined) {
    return { [propertyData]: { is_enabled: !!isEnabled } };
  }

  return { [propertyData]: { is_enabled: !!isEnabled, is_default: !!isDefault } };
};

export const putAppSettingsInternalUserGroupsInternalUserGroupUpdate = reactQueryMutationAdapter(
  internalUserGroupsInternalUserGroupUpdateCacheKeys,
  ({
    appGroupId,
    internalUserGroupId,
    name,
    isEnabledUserEventLog,
    isEnabledContentTest,
    isDefaultContentTest,
    isEnabledSeedGroup,
    isDefaultSeedGroup,
    territoryId,
  }: AppSettingsInternalUserGroupsInternalUserGroupUpdateOptions): Promise<InternalUserGroupsInternalUserGroupUpdateResult> => {
    const body = {
      name,
      ...(territoryId ? { territory_ids: [territoryId] } : {}),
      ...(internalUserGroupId ? { internal_user_group_id: internalUserGroupId } : {}),
      ...nestedPropertyData("user_event_log", isEnabledUserEventLog),
      ...nestedPropertyData("content_test", isEnabledContentTest, isDefaultContentTest),
      ...nestedPropertyData("seed_group", isEnabledSeedGroup, isDefaultSeedGroup),
    };

    return fetch(
      `/internal_user_groups/internal_user_group_update?app_group_id=${appGroupId}`,
      "PUT",
      body,
      undefined,
      {
        // don't display a modal on fetch errors
        propagateFetchRequestError: false,
      }
    );
  }
);
